import { Printer, Gift, Image, Palette } from 'lucide-react'
import { SEOTemplateBPage } from './SEOTemplateBPage'

export function SEODrucken() {
  return (
    <SEOTemplateBPage
      meta={{
        title: 'WhatsApp Chat drucken & ausdrucken – ChatArchiv.de',
        description: 'WhatsApp-Gespräche als druckfertiges PDF aufbereiten — mit Original-Layout, Fotos und Emojis. Perfekt zum Ausdrucken, Verschenken oder Einrahmen.',
      }}
      eyebrow="Drucken & Verschenken"
      h1="WhatsApp-Chats"
      h1accent="schön ausdrucken."
      sub="Aus dem Chatverlauf wird ein druckfertiges PDF — mit Sprechblasen, Fotos und dem vertrauten WhatsApp-Look. Perfekt zum Einrahmen oder Verschenken."
      features={[
        { icon: <Printer size={20} />, title: 'Druckfertig', desc: 'A4, optimiert für Druck' },
        { icon: <Gift size={20} />, title: 'Verschenken', desc: 'Als Buch oder gerahmt' },
        { icon: <Image size={20} />, title: 'Mit Fotos', desc: 'Bilder eingebettet' },
        { icon: <Palette size={20} />, title: 'Anpassbar', desc: 'Farben & Layout wählbar' },
      ]}
      contentBlocks={[
        { heading: "WhatsApp-Chat ausdrucken — so geht's richtig", text: 'WhatsApp selbst bietet keine Druckfunktion. Der direkte Screenshot-Druck ist unübersichtlich und unprofessionell. ChatArchiv.de wandelt deinen Chat in ein sauber formatiertes A4-PDF um — mit Sprechblasen, Zeitangaben und eingebetteten Fotos, das direkt beim Druckdienstleister bestellt oder zu Hause ausgedruckt werden kann.' },
        { heading: 'Ideen: Was du mit einem Chat-PDF machen kannst', text: 'Ein WhatsApp-PDF eignet sich als persönliches Geschenk (zum Beispiel die schönsten Nachrichten eines Jahres), als gerahmtes Kunstwerk, als Erinnerungsbuch für besondere Reisen oder als Chronik einer langen Freundschaft. Die Anpassungsoptionen in ChatArchiv lassen dich Farben und Layout individuell gestalten.' },
      ]}
      faq={[
        { q: 'In welchem Format wird das PDF erstellt?', a: 'Das PDF ist im A4-Format und für den Druck optimiert. Es kann direkt zu Hause oder bei einem Druckdienstleister ausgedruckt werden.' },
        { q: 'Kann ich das Layout vor dem Drucken anpassen?', a: 'Ja — in der Live-Vorschau kannst du Farben, Schriftgröße und weitere Optionen einstellen, bevor du das PDF generierst.' },
        { q: 'Werden Emojis korrekt gedruckt?', a: 'Ja, alle Emojis werden korrekt ins PDF eingebettet und erscheinen beim Druck genauso wie in WhatsApp.' },
        { q: 'Wie viele Seiten hat das PDF?', a: 'Die Seitenanzahl hängt von der Nachrichtenmenge ab. Ein Chat mit 1.000 Nachrichten ergibt typischerweise 40–80 Seiten.' },
      ]}
    />
  )
}
